var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdui-container"},[_c('div',{staticClass:"mdui-row"},[_c('div',{staticClass:"mdui-col-xs-12 mdui-col-lg-4 mdui-col-offset-lg-4"},[_c('My')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }